import { createAnimationAccess, ANIMATION_ACCESS_PATH } from "@heraion/shared";

import { apiFetch } from "./api";

// AN-6 — il montaggio web della porta CDN. La politica sta in @heraion/shared;
// qui c'è solo il trasporto, e la sua unica particolarità: `withCookies`.
//
// ⚠️ Senza `credentials: "include"` il browser riceve il Set-Cookie e lo BUTTA,
// senza errori e senza console: le animazioni andrebbero a 403 e sembrerebbe
// che non esistano. È il motivo per cui l'opzione esiste.
export const animationAccess = createAnimationAccess(() =>
  apiFetch<{ expiresAt: string }>(ANIMATION_ACCESS_PATH, {
    method: "POST",
    withCookies: true,
  }),
  (err) => console.warn("[animations] cookie non ottenuto", err),
);
